import { isNumber } from 'lodash';
import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Switch, useLocation } from 'react-router';
import { Client, Provider as ClientProvider } from 'urql';
import { Home, Loading, PrivateRoute, SignInForm, TerminalFromUrl, TerminalRoot, TerminalSelector } from '.';
import makeClient from '../client';
import themes from '../themes';
import { createGlobalStyle, ThemeProvider } from '../themes/themed-styled-components';
import CurrentUser from './CurrentUser';
import EmergencyCardsPage from './EmergencyCardsPage';
import Header from './Header';
import RegisterEndpoint from './RegisterEndpoint';
import ResetPasswordEndpoint from './ResetPasswordEndpoint';
import TerminalNavigation from './TerminalNavigation';
import { GridLayout } from './ui';
import UserManagement from './UserManagement';
import { PackagingsContext } from './../data/packagings';
import { UnNumbersContext } from '../data/unNumbers';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

const GlobalStyle = createGlobalStyle`
#root {
    height: 100vh;
}

body {
    color: ${({ theme }) => theme.bodyColor};
    font-family: ${({ theme }) => theme.fontFamilySansSerif};
}`

const Root = () => {
    const { t } = useTranslation('common');
    const [selectedTerminalId, setSelectedTerminalId] = useState<number | null>(null);

    const [client/*, setClient*/] = useState<Client>(makeClient);

    const { state, ...location } = useLocation<{ baseUrl: string }>();

    const header = useMemo(() => (
        <Header>
            <TerminalSelector id={selectedTerminalId} />
            <TerminalNavigation id={selectedTerminalId} />
        </Header>
    ), [selectedTerminalId]);

    //const resetClient = useCallback(() => {
    //    setClient(makeClient());
    //    setSelectedTerminalId(null);
    //}, [setClient]);

    const onTerminalChange = useCallback((id:any) => {
        if (isNumber(id)) {
            setSelectedTerminalId(id);
        }
    }, [setSelectedTerminalId])

    //if (process.env.NODE_ENV === 'development') {
    //    return <ThemeProvider theme={themes.default}>
    //        <ClientProvider value={client}>
    //            <GlobalStyle />
    //            <CurrentUser>
    //                <GridLayout header={headerNew}>
    //                    <Switch>
    //                        <Route path={`/registrazione`}>
    //                            <RegisterEndpoint />
    //                        </Route>

    //                        <Route path={`/recupero-password`}>
    //                            <ResetPasswordEndpoint />
    //                        </Route>

    //                        <PrivateRoute exact path="/">
    //                            <Home />
    //                        </PrivateRoute>

    //                        <PrivateRoute path={`/${t('userManagement.slug')}`}>
    //                            <UserManagement />
    //                        </PrivateRoute>

    //                        <Route path={`/${t('access.slug')}`}>
    //                            <SignInForm />
    //                        </Route>

    //                        <PrivateRoute path={`/${t('terminal')}`}>
    //                            Terminal
    //                        </PrivateRoute>
    //                    </Switch>
    //                </GridLayout>
    //            </CurrentUser>
    //        </ClientProvider>
    //    </ThemeProvider>
    //}

    return (
        <ThemeProvider theme={themes.default}>
            <QueryClientProvider client={queryClient}>
            <ClientProvider value={client}>
                <GlobalStyle />
                <CurrentUser onSignOut={() => setSelectedTerminalId(null)}>
                    <PackagingsContext lazy>
                        <UnNumbersContext>
                            <GridLayout header={header}>
                                <Switch location={{ state: { ...(state ?? {}), parentUrl: '' }, ...location }}>
                                    <Route path={`/registrazione`}>
                                        <RegisterEndpoint />
                                    </Route>

                                    <Route path={`/recupero-password`}>
                                        <ResetPasswordEndpoint />
                                    </Route>

                                    <PrivateRoute exact path="/">
                                        <Home />
                                    </PrivateRoute>

                                    <PrivateRoute path={`/${t('userManagement.slug')}`}>
                                        <UserManagement />
                                    </PrivateRoute>

                                    <PrivateRoute path={[`/${t('schede-di-emergenza')}/:hazardClass/:unNumber`, `/${t('schede-di-emergenza')}/:hazardClass`, `/${t('schede-di-emergenza')}`]} >
                                        <EmergencyCardsPage />
                                    </PrivateRoute>

                                    <Route path={`/${t('access.slug')}`}>
                                        <SignInForm />
                                    </Route>

                                    <PrivateRoute path={`/:slug`}>
                                        <TerminalFromUrl onChange={onTerminalChange} />
                                        {selectedTerminalId === null ? <Loading /> : <TerminalRoot key={selectedTerminalId} id={selectedTerminalId} />}
                                    </PrivateRoute>
                                </Switch>
                            </GridLayout>
                        </UnNumbersContext>
                    </PackagingsContext>
                </CurrentUser>
                </ClientProvider>
            </QueryClientProvider>
        </ThemeProvider >
    );
}

export default Root;